export enum Environment {
  Atest = 'atest',
  Development = 'development',
  Feature = 'feature',
  Local = 'local',
  Production = 'production',
  PTest = 'ptest',
  TreasuryStaging = 'treasury-staging',
}

export enum SkipVersionCheckForEnvironment {
  Localhost = 'localhost',
  Development = 'development'
}

export const SkipVersionCheckForEnvironments
  = [SkipVersionCheckForEnvironment.Localhost, SkipVersionCheckForEnvironment.Development] as const;

export type EnvironmentLabel = keyof typeof Environment;
